import { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { SelectInput } from '@interstate/components/SelectInput';

import { inventoryTypeSelectClicked } from '@makemydeal/dr-dash-store/actions/vehicleActionCreators';

import { dealLockHooks } from '../../hooks';
import { FormContext } from '../formManager/formContext';
import { FMField } from '../types';
import { VehicleInfoGrid } from './Style';

/**
 * Inventory Type dropdown shown in the Vehicle Details flyout for deals/quotes without a vehicle
 * (US2032152). It is wired into the drawer's form manager (via FormContext), so selecting a value
 * only stages the change - it is applied to the deal (and payment recalculated) when the user clicks
 * "Apply Changes", consistent with the rest of the flyout. Values match the offer's VehicleCondition.
 */
// Values are the canonical lower-case condition values stored on the offer (AccelerateVehicleCondition),
// so the current condition preselects correctly and the value stays consistent with the payment engine.
export const INVENTORY_TYPE_OPTIONS = [
    { label: 'New', value: 'new' },
    { label: 'Used', value: 'used' },
    { label: 'Certified Preowned', value: 'certified' }
];

export const InventoryTypeSelect = () => {
    const { form, changeHandler } = useContext(FormContext);
    const isLocked = dealLockHooks.useIsDealLocked();
    const dispatch = useDispatch();

    return (
        // Single-column grid so the dropdown takes ~half the flyout width, matching the design.
        <VehicleInfoGrid>
            <SelectInput
                data-testid="inventory-type-select"
                id={FMField.condition}
                name={FMField.condition}
                label="Inventory Type"
                options={INVENTORY_TYPE_OPTIONS}
                value={form.values[FMField.condition] as string}
                onChange={(ev) => {
                    dispatch(inventoryTypeSelectClicked());
                    changeHandler(FMField.condition, ev.target.value as string);
                }}
                displayDeselectOption={false}
                disabled={isLocked}
            />
        </VehicleInfoGrid>
    );
};

export default InventoryTypeSelect;
